import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { CancellationReadinessView } from '../components/views'

function CancellationReadiness() {
    return (
        <div className="cancellationReadiness">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="Cancellation readiness"
                        intro="Which introducer databases the cancel, reactivate and resend-letter actions can safely work against right now. Every check is read-only."
                    />
                    <CancellationReadinessView />
                </Page>
            </MainView>
        </div>
    )
}

export default CancellationReadiness
